
import React,{useState} from "react"

import { Button, FormControl, Grid, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material';
import userEditIcon from "../../assets/icons/user-edit.svg"
import userSettingIcon from "../../assets/icons/user-setting.svg"
import flightDeactivateIcon from "../../assets/icons/deactivate-flight.svg";
import flightActivateIcon from "../../assets/icons/activate-flight.svg";
import CommonModal from "../modal/CommonModal";
// import DeactivateUserModalBody from "./DeactivateUser";
// import EditUserModalBody from "./EditUser";
import { useNavigate } from "react-router-dom";
// import DeactivateFlight from "./DeactivateFlight";
import ActivateEmptyLegFlight from "./ActivateEmptyLegFlight";
import DeactivateEmptyLegFlight from "./DeactivateEmptyLegFlight";
// import ActivateUserModalBody from "./ActivateUser";
import editIcon from "../../assets/icons/edit-icon.svg";

export const ManageFlight = ({ flightId ,isActive,indexNumber,pageState,getEmptyLegFlights}:any) => {
    const [openDeactivateFlight, setOpenDeactivateFlight] = useState(false);
    const [openActivateFlight, setOpenActivateFlight] = useState(false);
    const handleOpenDeactivateFlightModal = () => setOpenDeactivateFlight(true)
    const handleCloseDeactivateFlightModal = () => setOpenDeactivateFlight(false);
    const [openEditFlight, setOpenEditFlight] = useState(false);
    const navigate= useNavigate()
   
    const handleOpenEditFlightModal = () => setOpenEditFlight(true)
    const handleCloseEditFlightModal = () => setOpenEditFlight(false);


    const handleOpenActivateFlightModal=()=> setOpenActivateFlight(true)
    const handleCloseActivateFlightModal=()=> setOpenActivateFlight(false)
    return (
       <>
        <CommonModal open={openDeactivateFlight} handleCloseModal={handleCloseDeactivateFlightModal} modalBody={<DeactivateEmptyLegFlight handleCloseDeactivateFlightModal={handleCloseDeactivateFlightModal} flightId={flightId} indexNumber={indexNumber} pageState={pageState} getEmptyLegFlights={getEmptyLegFlights}/>} />
        <CommonModal open={openActivateFlight} handleCloseModal={handleCloseActivateFlightModal} modalBody={<ActivateEmptyLegFlight handleCloseActivateFlightModal={handleCloseActivateFlightModal} flightId={flightId} indexNumber={indexNumber} pageState={pageState} getEmptyLegFlights={getEmptyLegFlights}/>} />
        {/* <CommonModal open={openEditUser} handleCloseModal={handleCloseEditUserModal} modalBody={<EditUserModalBody handleCloseEditUserModal={handleCloseEditUserModal} userId={userId}/>} /> */}
      <Grid container columnSpacing={2}>
        <Grid item xs={4} spacing={2}>
          <Tooltip title="Edit Flight">
            <Button onClick={()=>window.location.href=`/empty-leg-management/edit/${flightId}?index=${isActive?0:1}`}>
              <img src={editIcon} alt="edit icon" height="20px" width="20px" />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs={4}>
          <Tooltip title={`${isActive ? "Deactivate Flight":"Activate Flight"}`}>
            <Button onClick={isActive?handleOpenDeactivateFlightModal:handleOpenActivateFlightModal}>
              <img src={isActive ?flightDeactivateIcon : flightActivateIcon} alt="not allowed icon" height="20px" width="20px" />
            </Button>
          </Tooltip>
        </Grid>
    
      </Grid>
       </>
    );
  };
  